export default class MedicalLocation extends HTMLElement {
  static define(tagName = 'medical-location') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg width="64" height="64" pointer-events="none" viewBox="0 0 64 64">
  <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linejoin="round" stroke-width="3">
    <path d="M32.5 62S56 42.097 56 24.618C56 12.126 45.478 2 32.5 2 19.52 2 9 12.126 9 24.618 9 42.097 32.5 62 32.5 62z"/>
    <path d="M43.216 19.856a5.926 5.926 0 0 0-8.615 0l-2.101 2.19-2.101-2.19c-2.379-2.475-6.235-2.475-8.613 0-2.381 2.479-2.381 6.498 0 8.976L32.5 40l10.716-11.168c2.379-2.478 2.379-6.497 0-8.976z"/>
  </g>
</svg>
`;
  }
}
MedicalLocation.define();


// WEBPACK FOOTER //
// ./assets/icons/medical-location.svg